const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://1al7b2138d.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://yd66mcvvia.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'hotfix/CV4-3039-teams-add-team-site-junction-table-and-api-endpoints',
    HOSTNAME: 'https://teams-service.testing.platform.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.platform.forwoodsafety.com',
    WEBSOCKET: 'wss://0bmk6ppdq1.execute-api.us-west-2.amazonaws.com/testing'
  },
};

export default config;
